import { memo, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import FormBody from './FormBody';
import MpinBody from './MpinBody';

const LoginForm = ({
    text,
    showErrorBorder, handleUserIdPasswordOnChange, bLoginButton, objUserCredentials,
    mpinlogin, objLoginSession, handleLogin, showPassword, setShowPassword, handleSusequentPasswordLogin,
    handleMpinChange, mpin, setMpin, handleMpinKeyUp, mpinSuccessError, route, handleTakeMeToSelect, handleShow, handleForgetMpin, handleForgotPassword,
    activeProfile, setActiveProfile, usersModal, setUsersModal, handleSignup, spinner, setMpinSuccessError, userDetails, setUserDetails, handleFavorite, bMpinEnabled, handleUseAnotherAccount, handleUserChoice, inputRef, passwordRef, bSubLoginButton, user, setUser, handleMpinPassword, handleForgotUserId }) => {


        const [loginTab,setLoginTab] = useState('user_id')

    return (
        <>
            <div className='login-header'>
                <Header setLoginTab={setLoginTab} bMpinEnabled={bMpinEnabled} mpinlogin={mpinlogin} activeProfile={activeProfile} objLoginSession={objLoginSession} setUsersModal={setUsersModal} inputRef={inputRef} passwordRef={passwordRef} />
            </div>

            <div className='login-body'>
                {bMpinEnabled && mpinlogin === 'true' ? <MpinBody handleUseAnotherAccount={handleUseAnotherAccount} route={route} handleTakeMeToSelect={handleTakeMeToSelect} handleForgetMpin={handleForgetMpin} handleFavorite={handleFavorite} objUserCredentials={objUserCredentials}
                    handleSusequentPasswordLogin={handleSusequentPasswordLogin} usersModal={usersModal} setUserDetails={setUserDetails} handleUserIdPasswordOnChange={handleUserIdPasswordOnChange}
                    setUsersModal={setUsersModal} mpinSuccessError={mpinSuccessError} handleMpinKeyUp={handleMpinKeyUp} setMpinSuccessError={setMpinSuccessError}
                    handleMpinChange={handleMpinChange} mpin={mpin} setMpin={setMpin} activeProfile={activeProfile} objLoginSession={objLoginSession} handleForgotPassword={handleForgotPassword}
                    setActiveProfile={setActiveProfile} showPassword={showPassword} setShowPassword={setShowPassword} userDetails={userDetails} handleUserChoice={handleUserChoice} inputRef={inputRef} passwordRef={passwordRef} bSubLoginButton={bSubLoginButton} user={user} setUser={setUser} handleMpinPassword={handleMpinPassword} />
                    : <FormBody loginTab={loginTab} text={text} showErrorBorder={showErrorBorder} objUserCredentials={objUserCredentials} showPassword={showPassword}
                        setShowPassword={setShowPassword} handleUserIdPasswordOnChange={handleUserIdPasswordOnChange}
                        bLoginButton={bLoginButton} objLoginSession={objLoginSession} handleLogin={handleLogin}
                        handleSignup={handleSignup} spinner={spinner} route={route} handleTakeMeToSelect={handleTakeMeToSelect} handleForgotPassword={handleForgotPassword}
                        handleShow={handleShow} handleMpinPassword={handleMpinPassword} handleForgotUserId={handleForgotUserId} />
                }
            </div>

            <div className='login-footer'>
                <Footer />
            </div>

        </>
    );
};

export default memo(LoginForm);
